<template>
	<div class="relative flex h-2 gap-0.5 rounded-xs bg-black p-0.5">
		<div
			class="flex-1"
			:class="{
				'bg-fill-secondary': value > 25,
				'bg-green-dark': 0 <= value && value <= 25
			}"
		></div>
		<div
			class="flex-1"
			:class="{
				'bg-fill-secondary': value <= 25 || value > 50,
				'bg-yellow-dark': 25 < value && value <= 50
			}"
		></div>
		<div
			class="flex-1"
			:class="{
				'bg-fill-secondary': value <= 50 || value > 75,
				'bg-orange-dark': 50 < value && value <= 75
			}"
		></div>
		<div
			class="flex-1"
			:class="{
				'bg-fill-secondary': value < 75,
				'bg-red-dark': 75 < value
			}"
		></div>
		<div
			class="absolute -top-0.5 h-3 w-0.5 -translate-x-1 bg-white transition-transform"
			:style="{ left: `${value}%` }"
			:class="{
				'-translate-x-1': !loaded,
				'-translate-x-px': loaded
			}"
		></div>
	</div>
</template>
<script setup lang="ts">
import { sleep } from '@/utils/sleep'
import { ref } from 'vue'

defineProps<{
	value: number
}>()

const loaded = ref(false)

const onLoad = async () => {
	await sleep(100)
	loaded.value = true
}

onLoad()
</script>
